"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertFunctionParams;

var _core = require("@babel/core");

var _shadowUtils = require("./shadow-utils");

var buildDefaultParam = _core.template.statement("\n  let VARIABLE_NAME =\n    arguments.length > ARGUMENT_KEY && arguments[ARGUMENT_KEY] !== undefined ?\n      arguments[ARGUMENT_KEY]\n    :\n      DEFAULT_VALUE;\n");

var buildLooseDefaultParam = _core.template.statement("\n  if (ASSIGNMENT_IDENTIFIER === UNDEFINED) {\n    ASSIGNMENT_IDENTIFIER = DEFAULT_VALUE;\n  }\n");

var buildLooseDestructuredDefaultParam = _core.template.statement("\n  let ASSIGNMENT_IDENTIFIER = PARAMETER_NAME === UNDEFINED ? DEFAULT_VALUE : PARAMETER_NAME ;\n");

var buildSafeArgumentsAccess = _core.template.statement("\n  let $0 = arguments.length > $1 ? arguments[$1] : undefined;\n");

function convertFunctionParams(path, ignoreFunctionLength, shouldTransformParam, replaceRestElement) {
  var params = path.get("params");
  var isSimpleParameterList = params.every(function (param) {
    return param.isIdentifier();
  });
  if (isSimpleParameterList) return false;
  var node = path.node,
      scope = path.scope;
  var body = [];
  var shadowedParams = new Set();

  var _iterator = _createForOfIteratorHelper(params),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _param2 = _step.value;
      (0, _shadowUtils.collectShadowedParamsNames)(_param2, scope, shadowedParams);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var state = {
    needsOuterBinding: false,
    scope: scope
  };

  if (shadowedParams.size === 0) {
    var _iterator2 = _createForOfIteratorHelper(params),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var param = _step2.value;
        if (!param.isIdentifier()) param.traverse(_shadowUtils.iifeVisitor, state);
        if (state.needsOuterBinding) break;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  var firstOptionalIndex = null;

  for (var i = 0; i < params.length; i++) {
    var _param = params[i];

    if (shouldTransformParam && !shouldTransformParam(i)) {
      continue;
    }

    var transformedRestNodes = [];

    if (replaceRestElement) {
      replaceRestElement(path, _param, transformedRestNodes);
    }

    var paramIsAssignmentPattern = _param.isAssignmentPattern();

    if (paramIsAssignmentPattern && (ignoreFunctionLength || _core.types.isMethod(node, {
      kind: "set"
    }))) {
      var left = _param.get("left");

      var right = _param.get("right");

      var undefinedNode = scope.buildUndefinedNode();

      if (left.isIdentifier()) {
        body.push(buildLooseDefaultParam({
          ASSIGNMENT_IDENTIFIER: _core.types.cloneNode(left.node),
          DEFAULT_VALUE: right.node,
          UNDEFINED: undefinedNode
        }));

        _param.replaceWith(left.node);
      } else if (left.isObjectPattern() || left.isArrayPattern()) {
        var paramName = scope.generateUidIdentifier();
        body.push(buildLooseDestructuredDefaultParam({
          ASSIGNMENT_IDENTIFIER: left.node,
          DEFAULT_VALUE: right.node,
          PARAMETER_NAME: _core.types.cloneNode(paramName),
          UNDEFINED: undefinedNode
        }));

        _param.replaceWith(paramName);
      }
    } else if (paramIsAssignmentPattern) {
      if (firstOptionalIndex === null) firstOptionalIndex = i;

      var _left = _param.get("left");

      var _right = _param.get("right");

      var defNode = buildDefaultParam({
        VARIABLE_NAME: _left.node,
        DEFAULT_VALUE: _right.node,
        ARGUMENT_KEY: _core.types.numericLiteral(i)
      });
      body.push(defNode);
    } else if (firstOptionalIndex !== null) {
      var _defNode = buildSafeArgumentsAccess([_param.node, _core.types.numericLiteral(i)]);

      body.push(_defNode);
    } else if (_param.isObjectPattern() || _param.isArrayPattern()) {
      var uid = path.scope.generateUidIdentifier("ref");
      uid.typeAnnotation = _param.node.typeAnnotation;

      var _defNode2 = _core.types.variableDeclaration("let", [_core.types.variableDeclarator(_param.node, uid)]);

      body.push(_defNode2);

      _param.replaceWith(_core.types.cloneNode(uid));
    }

    if (transformedRestNodes) {
      var _iterator3 = _createForOfIteratorHelper(transformedRestNodes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var transformedNode = _step3.value;
          body.push(transformedNode);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }

  if (firstOptionalIndex !== null) {
    node.params = node.params.slice(0, firstOptionalIndex);
  }

  path.ensureBlock();

  if (state.needsOuterBinding || shadowedParams.size > 0) {
    body.push((0, _shadowUtils.buildScopeIIFE)(shadowedParams, path.node.body));
    path.set("body", _core.types.blockStatement(body));
    var bodyPath = path.get("body.body");
    var arrowPath = bodyPath[bodyPath.length - 1].get("argument.callee");
    arrowPath.arrowFunctionToExpression();
    arrowPath.node.generator = path.node.generator;
    arrowPath.node.async = path.node.async;
    path.node.generator = false;
  } else {
    path.get("body").unshiftContainer("body", body);
  }

  return true;
}